import { Component, OnInit,Inject,Output, EventEmitter ,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-edit-rrms-probedb-allowed-gt',
  templateUrl: './edit-rrms-probedb-allowed-gt.component.html',
  styleUrls: ['./edit-rrms-probedb-allowed-gt.component.scss']
})
export class EditRrmsProbedbAllowedGtComponent implements OnInit {

  @Output() refreshTableData = new EventEmitter();
  updateprobdbAllowedGtFormGroup:FormGroup;
  itemData:any;
  allowedgt:any;
 Type:any;

  constructor(public dialogRef: MatDialogRef<EditRrmsProbedbAllowedGtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder:FormBuilder , private endpointsService: EndpointsService, private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.spinnerService.show();
    

      this.itemData = this.data.rowData;
      this.Type= this.data.type
      console.log("itemData",this.itemData)
      console.log("jt",this.itemData.gt)
      console.log("orgIIIID",this.Type)
      console.log("this.typeeeee",this.itemData.type)
      let apiUrl = this.endpointsService.URL_GET_RRMS_PROBRDB_ALLOWED_GT + '&gt='+ this.itemData.gt + '&type='+ this.Type  ;
   
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.allowedgt = response;
      console.log("respone333",response)
    });
    this.updateprobdbAllowedGtFormGroup = this.formBuilder.group({  
      // sno:[],
      // orgId:[],
      gt:[]
      })
      setTimeout(()=>{
        this.editAllowedGtForm();
        this.spinnerService.hide();
      },5000)
  }
  editAllowedGtForm(){
    this.updateprobdbAllowedGtFormGroup = this.formBuilder.group({
      
      // sno:[this.allowedgt[0].sno],
      // sno:[this.allowedgt[0].sno],
      gt:[this.allowedgt[0].gt]
  
      })
  }
  onClose(){
    this.dialogRef.close();
  }
  onUpdate(){
   
    this.spinnerService.show();
    this.backendApiService.callToApi(this.endpointsService.URL_UPDATE_RRMS_PROBRDB_ALLOWED_GT +

    
      '&gt=' + this.updateprobdbAllowedGtFormGroup.get('gt').value+
       '&type='+ this.Type 
      
      
      
      )
      .subscribe(response => {
        console.log("responseeee",response)
        this.spinnerService.hide();
        if (response === null || response === false ||  response === "{\"status\" : \"false\"}") {
          alert('Not updated');
          this.dialogRef.close(false);

          return;
        } else {
          alert('Update successfully');
          this.dialogRef.close(true);
          this.spinnerService.show();
          this.refreshTableData.emit();
         
        }
  })
 
  }

}
